import React, { useEffect } from 'react';
import {
  Flex,
  HeaderCenterType,
  Image,
  Typography,
  theme,
} from '@goalsetter/ant-design-ui';
import * as Sentry from '@sentry/react';

import i18n from '@/localization/i18n';
import Images from '@/assets/img/Images';
import {
  imageStyles,
  whiteTextStyle,
  StyledNoContentContainer,
} from '../something-went-wrong-error/styles';
import { setHeaderProps } from '@/redux/slices/layout';
import { useDispatch } from 'react-redux';
import { AppDispatch } from '@/types/redux';

const { Title, Text } = Typography;

const { useToken } = theme;

const SomethingWentWrongTeacherSignUpPage = () => {
  const { token } = useToken();
  const dispatch = useDispatch<AppDispatch>();

  useEffect(() => {
    dispatch(
      setHeaderProps({
        headerCenterProps: {
          type: HeaderCenterType.IMAGE,
          imageSource: Images.LOGO,
          alt: 'Moneylingo logo',
        },
      }),
    );

    // Add breadcrumb to track when users reach this page
    // Note: API errors are already reported to Sentry via the ApiBase interceptor
    Sentry.addBreadcrumb({
      category: 'navigation',
      message: 'User reached something-went-wrong-error page',
      level: 'error',
      data: {
        referrer: document.referrer,
      },
    });
  }, [dispatch]);

  return (
    <>
      <StyledNoContentContainer>
        <Flex
          gap={24}
          vertical
          align="center"
        >
          <Image
            src={Images.FAILED}
            alt="Placeholder"
            aria-hidden="true"
            style={imageStyles}
          />
          <Flex
            gap={8}
            vertical
            align="center"
          >
            <Title
              level={3}
              style={whiteTextStyle}
            >
              {i18n.t('somethingWentWrongError.title')}
            </Title>
            <Text
              style={whiteTextStyle}
              color={token.colorTextLightSolid}
            >
              {i18n.t('somethingWentWrongError.subtitleTeacherSignUp')}
            </Text>
          </Flex>
        </Flex>
      </StyledNoContentContainer>
    </>
  );
};

export default SomethingWentWrongTeacherSignUpPage;
